/** Tipos de regime de execução de um contrato. */
export enum EManagementType {
  GLOBAL = "global",
  UNIT_PRICE = "preco-unitario",
}
